import { render, staticRenderFns } from "./BiosignsAccessCodesTable.vue?vue&type=template&id=19a3f51a"
import script from "./BiosignsAccessCodesTable.vue?vue&type=script&lang=js"
export * from "./BiosignsAccessCodesTable.vue?vue&type=script&lang=js"
import style0 from "./BiosignsAccessCodesTable.vue?vue&type=style&index=0&id=19a3f51a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports